import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'fury-add-edit-first-question',
  templateUrl: './add-edit-first-question.component.html',
  styleUrls: ['./add-edit-first-question.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AddEditFirstQuestionComponent implements OnInit {

  firstQuestionForm!: FormGroup;
  questionId: string;
  questionDetails: any;
  constructor(
    private apiService: ApiService, 
    private activatedRoute: ActivatedRoute, 
    public location: Location
    ) { 
      this.questionId = this.activatedRoute.snapshot.params["id"];
      if(this.questionId){
        this.getQuestionDetails();
      }
    }

  ngOnInit(): void {
    this.formInit();

    this.firstQuestionForm.get('type').valueChanges.subscribe((res) => {
      const optionsControl = this.firstQuestionForm.get('options');
      if(res === 'Dropdown'){
        optionsControl.setValidators([Validators.required]);
        this.addOption();
      } else {
        optionsControl.clearValidators();
        this.clearOptions();
      }
      optionsControl.updateValueAndValidity();
    })
  }

  formInit(){
    this.firstQuestionForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      type: new FormControl('', [Validators.required]),
      isRequired: new FormControl('', [Validators.required]),
      options : new FormArray([]),
    })
  }

  getQuestionDetails(){
    this.apiService.get(`admin/claim/first-question/get-first-question/${this.questionId}`).subscribe((res : HttpResponse<any>)=>{
      if(res?.body){
        this.questionDetails = res?.body?.firstQuestion;
        this.firstQuestionForm.patchValue(res?.body?.firstQuestion);
        if(this.questionDetails?.options){
          let data: any[] = res.body.firstQuestion?.options;
          data.shift();
          this.firstQuestionForm.patchValue({
            options: data.forEach(element => {
              this.options.push(new FormControl(element, [Validators.required, Validators.minLength(2)]));
            })
          })
        }
      }
    })
  };

  get options() : FormArray {
    return this.firstQuestionForm.get("options") as FormArray
  };

  addOption() {
    this.options.push(new FormControl('', [Validators.required, Validators.minLength(2)]));
  };

  removeOption(index: number) {
    this.options.removeAt(index);
  };
  clearOptions() {
    this.options.clear();
  };
  
  addEdit(){
    if(this.firstQuestionForm.valid){
      const data = this.firstQuestionForm.value;

      if(!this.questionId){
        this.apiService.post('admin/claim/first-question/create-first-question', data).subscribe((res: any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          if(err){
            this.apiService.alert(err.message, ErrorType.Error);
          }
        })
      } else {
        this.apiService.patch(`admin/claim/first-question/update-first-question/${this.questionId}`, data).subscribe((res : any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          if(err){
            this.apiService.alert(err.message, ErrorType.Error);
          }
        })
      }
      
    } else {
      this.firstQuestionForm.markAllAsTouched();
    }
  }

}
